import { connect } from 'react-redux'
import { NotFoundComponent } from './NotFoundComponent'
import {
    fetchNotFoundPageData,
    resetNotFoundPageData
} from 'shared/store/not-found'
import type { Dispatch } from 'redux'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => state.notFoundPageState

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: () => d(fetchNotFoundPageData()),
    resetNotFoundPageData: () => d(resetNotFoundPageData()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta))
})

const NotFound = connect(mapStateToProps, mapDispatchToProps)(NotFoundComponent)

export { NotFound }
